import { useState } from 'react'
import { Button, Checkbox, Flex, Table, Text } from '@mantine/core'
import classes from './AdminSettings.module.css'

export const LocationAutoTagging = () => {
  const [selectedAll, setSelectedAll] = useState<boolean>(false)
  const [selectedRows, setSelectedRows] = useState<string[]>([])

  const data = [
    {
      tag: 'SHC',
      description:
        'Severe health conditions (seizures, heart disease, cancer, transplants, immunocompromised, etc.).',
      category: 'Health',
    },
    {
      tag: 'MHC',
      description:
        'Major health conditions (asthma, diabetes, major surgeries, etc.).',
      category: 'Health',
    },
    {
      tag: 'ASA',
      description:
        'Severe or life-threatening allergies (anaphylaxis, epi-pens, etc.).',
      category: 'Health',
    },
    {
      tag: 'SN',
      description: 'Any severe condition.',
      category: 'Health',
    },
    {
      tag: 'HIMP',
      description: 'Hearing impairments.',
      category: 'Health',
    },
    {
      tag: 'VIMP',
      description: 'Visual impairments.',
      category: 'Health',
    },
    {
      tag: 'MIMP',
      description: 'Mobility impairments.',
      category: 'Health',
    },
    {
      tag: 'DABIL',
      description:
        'Other forms of disability, disorder, and impairment (learning, emotional, psychological, behavioral, etc.)',
      category: 'Health',
    },
    {
      tag: 'GRF',
      description: 'Evidence of grief, sadness, loss, etc.',
      category: 'Needs',
    },
    {
      tag: 'DVCE',
      description: 'Lacking a device or connectivity.',
      category: 'Needs',
    },
    {
      tag: 'OLEARN',
      description: 'Assistance with online learning, testing, etc.',
      category: 'Needs',
    },
    {
      tag: 'HSNG',
      description: 'Assistance with rent, housing, shelter, utilities, etc.',
      category: 'Needs',
    },
    {
      tag: 'FUD',
      description:
        'Assistance with food supports (free lunch, SNAP, EBT, pantries, etc.)',
      category: 'Needs',
    },
    {
      tag: 'CAST',
      description:
        'Cash assistance (job loss, disability, childcare, hardship, etc.)',
      category: 'Needs',
    },
    {
      tag: 'SPECN',
      description:
        'Special needs (testing and evaluation needs, learning disabilities, communication issues, etc.)',
      category: 'Needs',
    },
    {
      tag: 'FAMS',
      description:
        'Parent/family supports (custody, runaway, curfew, family justice, etc.)',
      category: 'Needs',
    },
  ]

  const rows = data.map((item) => (
    <Table.Tr
      key={item.tag}
      bg={
        selectedRows.includes(item.tag)
          ? 'var(--mantine-color-blue-light)'
          : undefined
      }
    >
      <Table.Td w={20}>
        <Checkbox
          size="xs"
          aria-label="Select row"
          checked={selectedRows.includes(item.tag)}
          onChange={(event) =>
            setSelectedRows(
              event.currentTarget.checked
                ? [...selectedRows, item.tag]
                : selectedRows.filter((tag: string) => tag !== item.tag),
            )
          }
        />
      </Table.Td>

      <Table.Td style={{ whiteSpace: 'pre' }}>{item.tag}</Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>{item.description}</Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>{item.category}</Table.Td>
    </Table.Tr>
  ))

  const handleToggleSelectAll = () => {
    setSelectedAll(!selectedAll)
    !selectedAll
      ? setSelectedRows(data.map((curr) => curr.tag))
      : setSelectedRows([])
  }

  return (
    <>
      <Text p="md">
        Programmatically look for indications of certain health conditions,
        needs, and other vulnerabilities, and auto-tag records so that teams can
        follow up, ask questions, proactively address issues, etc. Records are
        reevaluated at each profile update. Staff can edit or remove these tags
        anytime.
      </Text>
      <Table withRowBorders={false} verticalSpacing="xs" mt="xs">
        <Table.Thead>
          <Table.Tr className={classes.AdminSettings__thead}>
            <Table.Th w={30}>
              <Checkbox
                size="xs"
                aria-label="Select row"
                checked={selectedAll}
                onChange={handleToggleSelectAll}
              />
            </Table.Th>

            <Table.Th key={`columns-1`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Tag
              </Text>
            </Table.Th>

            <Table.Th key={`columns-2`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Description
              </Text>
            </Table.Th>

            <Table.Th key={`columns-3`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Category
              </Text>
            </Table.Th>

            <Table.Th w={30} />
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
      <Flex p="md" pr="xl" mt="lg" justify="flex-end" gap="xs">
        <Button size="md" variant="default">
          Discard Changes
        </Button>
        <Button size="md">Save</Button>
      </Flex>
    </>
  )
}
